import Lottie from 'lottie-react';
import LoadingScreenPokerX3 from '@/assets/animations/Poker Cards/LoadingScreen_Poker_x3.json';
import LoadingScreenPokerX4 from '@/assets/animations/Poker Cards/LoadingScreen_Poker_x4.json';

interface PokerLogoProps {
  variant?: 'x3' | 'x4';
  className?: string;
}

const PokerLogo: React.FC<PokerLogoProps> = ({
  variant = 'x3',
  className = '',
}) => {
  const animationData =
    variant === 'x3' ? LoadingScreenPokerX3 : LoadingScreenPokerX4;
  return (
    <div className={className}>
      <Lottie loop={true} autoplay={true} animationData={animationData} />
    </div>
  );
};

export default PokerLogo;
